import { render, staticRenderFns } from "./GestationalAgeChoose.vue?vue&type=template&id=359c7a3a&scoped=true&"
import script from "./GestationalAgeChoose.vue?vue&type=script&lang=js&"
export * from "./GestationalAgeChoose.vue?vue&type=script&lang=js&"
import style0 from "./GestationalAgeChoose.vue?vue&type=style&index=0&id=359c7a3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359c7a3a",
  null
  
)

export default component.exports